// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["styles/portfolio","styles/DF"], () => (__webpack_require__("./src/scripts/app.js")))
__webpack_require__.O(undefined, ["styles/portfolio","styles/DF"], () => (__webpack_require__("./src/styles/DF.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["styles/portfolio","styles/DF"], () => (__webpack_require__("./src/styles/portfolio.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
